module.exports = __webpack_public_path__ + "img/37@2x.be78ad18.png";